import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

const StyledList = styled.ul`
  margin: 0;
  padding: 8px 0;
  list-style: none;
  overflow: auto;
  background-color: #fff;
  color: ${colors.slate__4c566c};
`;

export class List extends React.PureComponent<{ role: string }, {}> {
  public render() {
    return <StyledList>{this.props.children}</StyledList>;
  }
}

export default List;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/List/List.tsx